<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "PurgeAllRejectedGlyphsModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      isRefining: false,
    };
  },
  computed: {
    refiningOrSacrificing() {
      if (this.isRefining) return `Переработать`;
      return `Жертвовать`;
    },
    topLabel() {
      return `Вы собираетесь ${this.refiningOrSacrificing} все отклонённые Глифы`;
    },
    message() {
      const negativeWarning = AutoGlyphProcessor.hasNegativeEffectScore()
        ? ` Заметьте, что некоторые очки из ваших Фильтров Эффектов отрицательные, что может привести к потере некоторых
          Глифов, которые вы обычно хотите сохранить.`
        : "";
      return `Вы уверены, что хотите ${this.refiningOrSacrificing} все отклонённые Глифы? Это удалит
        все Глифы которые будут отклонены вашими текущими настройками Фильтра Глифов.${negativeWarning}`;
    },
    extraMessage() {
      if (this.glyphsDeleted === 0) return `Это не удалит никакие Глифы.`;
      if (this.glyphsDeleted === this.glyphsTotal) return `Это удалит все ваши Глифы.`;
      return `Этот процесс удалит ${this.glyphsDeleted}/${this.glyphsTotal} Глиф.`;
    },

    // These two don't need to be reactive since the modal force-closes itself whenever glyphs change
    glyphsTotal() {
      return Glyphs.inventory.filter(slot => slot !== null).length;
    },
    glyphsDeleted() {
      return Glyphs.deleteAllRejected(false);
    },
  },
  methods: {
    update() {
      this.isRefining = GlyphSacrificeHandler.isRefining;
    },
    handleYesClick() {
      Glyphs.deleteAllRejected(true);
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="sacrificeAll"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ topLabel }}
    </template>
    <div class="c-modal-message__text">
      {{ message }}
    </div>
    <br>
    <div class="c-modal-hard-reset-danger">
      {{ extraMessage }}
    </div>
  </ModalWrapperChoice>
</template>
